export default __webpack_public_path__ + "static/request-main-aaf9575321bac103cd84e998d8a7d8dc.webp";